#import '../fragment/user.graphql'

query teliaUsers {
  teliaUsers {
    ...userFragment
  }
}
